export interface DecorationOptions {
    container: HTMLDivElement;
    visible?: boolean;
    names?: DecorationName[];
    url?: string;
}

export type DecorationName =
    | "orchestra-1"
    | "orchestra-3"
    | "orchestra-4"
    | "orchestra-5"
    | "orchestra-6"
    | "orchestra-7"
    | "orchestra-14"

    | "orchestra-selector-1"
    | "orchestra-selector-2"
    | "orchestra-selector-6"
    | "orchestra-selector-14"

    | "melody-instrument-selector-1"
    | "melody-instrument-selector-2"
    | "melody-instrument-selector-10"
    | "melody-instrument-selector-12"
    | "melody-instrument-selector-13"

    | "melody-instrument-1"
    | "melody-instrument-6"

    | "melody-selector-1"
    | "melody-selector-2"
    | "melody-selector-10"
    | "melody-selector-13"

    | "person-selector-1"
    | "person-selector-6"
    | "person-selector-17"
    | "person-selector-15"

    | "person-detail-2"
    | "person-detail-6"
    | "person-detail-10"
    | "person-detail-16"
    | "person-detail-14"

export class Decoration {

    private _element: HTMLElement;
    private _options: DecorationOptions;

    constructor(options: DecorationOptions) {
        options = e5.object.merge({
            container: null,
            visible: false
        } as DecorationOptions, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "decoration";

        this.visible = options.visible;

        if (options.names) {
            this.addNames(options.names);
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public addNames(names: DecorationName[]): DecorationItem[] {
        const result: DecorationItem[] = [];
        for (let d of names) {
            result.push(
                this.add({
                    name: d
                })
            );
        }
        return result;
    }

    public add(options: DecorationItemOptions): DecorationItem {
        options = e5.object.merge({
        } as DecorationItemOptions, options);

        const item = new DecorationItem(options);
        this._element.appendChild(item.element);
        return item;
    }

    public get visible(): boolean {
        return !this._element.classList.contains("decoration--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("decoration--hidden", !value);
    }
}


export interface DecorationItemOptions {
    name: string;
}

export class DecorationItem {
    public readonly element: HTMLImageElement;

    private _options: DecorationItemOptions;

    constructor(options: DecorationItemOptions) {
        options = e5.object.merge({
        } as DecorationItemOptions, options);
        this._options = options;

        this.element = document.createElement("img");
        this.element.draggable = false;
        this.element.className = "decoration__item decoration__item--name-" + options.name;
    }
}